module.exports = __webpack_public_path__ + "img/down_app_content.dd82d334.png";